import React from "react";

// Matches US-style phone numbers inside free text, e.g.
// "+1(407)873-1668", "(407) 873-1668", "407-873-1668", "4078731668"
const PHONE_RE = /(?<!\d)(\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}(?!\d)/g;

export function telHref(raw) {
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 10) return `tel:+1${digits}`;
  return `tel:+${digits}`;
}

/**
 * Turns phone numbers inside a plain-text string into tap-to-call links.
 * Returns a React fragment; non-string input is passed through untouched.
 */
export function linkifyPhones(text, className = "text-[#DC2626] font-medium underline underline-offset-2") {
  if (typeof text !== "string" || !text) return text;
  const re = new RegExp(PHONE_RE.source, "g");
  const parts = [];
  let last = 0;
  let m;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    parts.push(
      <a
        key={`ph-${m.index}`}
        data-testid="note-phone-link"
        href={telHref(m[0])}
        className={className}
      >
        {m[0]}
      </a>
    );
    last = m.index + m[0].length;
  }
  if (parts.length === 0) return text;
  if (last < text.length) parts.push(text.slice(last));
  return <>{parts}</>;
}
